import { Navigate } from 'react-router-dom';
import { getSchoolRoutes } from './schoolRoutes';
import { getPaymentRoutes } from './paymentRoutes';
import { getPledgeRoutes } from './pledgeRoutes';
import { getDonorRoutes } from './donorRoutes';
import { getHubRoutes } from './hubRoutes';
import { getAuthRoutes } from './authRoutes';
import { getParentLoginRoutes } from './parentLoginRoutes';
import { getDonorLoginRoutes } from './donorLoginRoutes';
import { getMiscRoutes } from './miscRoutes';
import { getQueriesRoutes } from './queriesRoutes';
import { getSupportRoutes } from './supportRoutes';
import { getComingSoonRoutes } from './comingSoonRoutes';

/**
 * Main route configuration
 * Combines all feature-based route modules
 */
export const getRoutes = ({
  loggedIn,
  portalUserLoggedIn,
  hubUserLoggedIn,
  donorLoggedIn,
  supportLoggedIn,
  allowHub,
  visibleTabs,
  location,
  isDonorOrg
}) => {
  const defaultRedirect = isDonorOrg ? '/donors/login' : '/login';
  const preferSupportPicker = !loggedIn && supportLoggedIn;
  const loginRedirect = preferSupportPicker
    ? '/support-login'
    : (isDonorOrg ? '/donors/login' : '/login');

  return [
    // Root redirect
    {
      path: '/',
      element: <Navigate to={preferSupportPicker ? '/support-login' : defaultRedirect} />
    },

    // School routes (Parents, Students, Payments, Charges, etc.)
    ...getSchoolRoutes(loggedIn, visibleTabs, location, loginRedirect),

    // Payment routes
    ...getPaymentRoutes(loggedIn, visibleTabs, location, loginRedirect),

    // Pledge routes
    ...getPledgeRoutes(loggedIn, visibleTabs, location, loginRedirect),

    // Donor routes
    ...getDonorRoutes(loggedIn, visibleTabs, location, loginRedirect),

    // Queries (ask in plain language)
    ...getQueriesRoutes(loggedIn, visibleTabs, location, loginRedirect),

    // "Soon" sidebar links (screens still Windows-only)
    ...getComingSoonRoutes(loggedIn, loginRedirect),

    // Hub/Tasks routes
    ...getHubRoutes(loggedIn, hubUserLoggedIn, allowHub, loginRedirect, location),

    // Support client-update area (role=support only; hidden while impersonating)
    ...getSupportRoutes(supportLoggedIn),

    // Authentication routes
    ...getAuthRoutes(isDonorOrg),

    // Parent login portal routes
    ...getParentLoginRoutes(),

    // Donor login portal routes
    ...getDonorLoginRoutes(donorLoggedIn),

    // Misc routes (Settings, Features, 404)
    ...getMiscRoutes(loggedIn, portalUserLoggedIn, loginRedirect)
  ];
};

